import firebase from "firebase";
import "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

var firebaseConfig = {
  apiKey: "AIzaSyCDFc2-8wd-_-gpTc7rLcT3PYrHrx0rmdY",
  authDomain: "reveal-spa.firebaseapp.com",
  projectId: "reveal-spa",
  storageBucket: "reveal-spa.appspot.com",
  messagingSenderId: "345105313128",
  appId: "1:345105313128:web:0053563f066f1bb0e1fadd",
  measurementId: "G-E0G6BFHF0B"
};

firebase.initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export default firebase
